import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=0590a75c"
import script from "./CommonModal.vue?vue&type=script&lang=js"
export * from "./CommonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports